// extracted by mini-css-extract-plugin
module.exports = {"headingWrapper":"WJYT7","heading":"QkUnA","signUpInfo":"_3uDDl"};